import { APIMethod, fetchData } from "@client";

export async function removeProjectCommentQuery(uuid, id) {
  const data = { uuid, id };
  return await fetchData("/project/comment", APIMethod.DELETE, { data });
}
